import { TransactionApi } from 'api';
import { ThunkDispatch } from 'redux-thunk';
import { IN_GAME_COUPON_COUNT } from 'shared/store/action-types';
import { createAction } from 'shared/util/utility';

const fetchInGameCouponCount = () => {
	return async (dispatch: ThunkDispatch<{}, {}, any>) => {
		try {
			const response = await TransactionApi.getNumOfInGameCouponCount();

			if (response?.data?.data) {
				const numOfInGameCouponCount = response.data.data;

				dispatch(createAction(IN_GAME_COUPON_COUNT, numOfInGameCouponCount));
			}
		} catch (error) {
			console.error(error);
		}
	};
};

export default fetchInGameCouponCount;
